<template>
  <div class="pre-guide-wrapper">
    <div class="header-wrap">
      <div class="title">您已成功购买人工智能Python体验课</div>
      <div class="desc">风变人工智能将为您建立个人学习档案</div>
    </div>
    <div class="content-wrap">
      <img
        class="avatar"
        src="https://res.pandateacher.com/6Q5JG6LD1629253520431.png"
      />
      <div>
        <div class="content">Hi~~我是风变人工智能小Q</div>
        <div class="content">欢迎来到风变编程, 机会总是留给有准备的你。</div>
        <div class="content">
          为了给你提供更好的教学服务, 我希望通过几个小问题再了解你一些,
          <span class="highlight">约用时1分钟~</span>
        </div>
      </div>
    </div>
    <div class="btn" @click="handleStart">开始</div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import Popup from '@component/Popup/';
import { IQuestion, IAnswerItem, IOption } from './types';

@Component({
  components: { Popup },
})
export default class PreGuide extends Vue {
  handleStart() {
    this.$emit('start');
  }
}
</script>

<style lang="scss" scoped vars="{ques-theme-bg}">
$theme-color: var(--ques-theme-bg);
$color-font: #382d68;

.pre-guide-wrapper {
  width: 100vw;

  .header-wrap {
    width: 100%;
    height: 278px;
    padding: 60px 30px;
    background-image: url(https://res.pandateacher.com/RAONTVX51629253520460.png);
    background-repeat: no-repeat;
    background-size: contain;

    .title {
      height: 40px;
      margin-bottom: 8px;
      color: $color-font;
      font-size: 28px;
      line-height: 40px;
    }
    .desc {
      color: $theme-color;
      font-weight: 600;
      font-size: 32px;
      line-height: 45px;
    }
  }
  .content-wrap {
    display: flex;
    max-height: 40vh;
    margin-bottom: 140px;
    padding: 0 32px;
    overflow: scroll;
    .avatar {
      width: 86px;
      height: 86px;
      margin-right: 16px;
      border-radius: 50%;
    }
    .content {
      position: relative;
      max-width: 560px;
      margin-left: 24px;
      padding: 24px 32px;
      color: $color-font;
      font-size: 28px;
      line-height: 46px;
      background-color: rgba(245, 245, 251, 1);
      border-radius: 0px 16px 16px 16px;

      &:not(:last-child) {
        margin-bottom: 32px;
      }

      .highlight {
        color: $theme-color;
      }

      &::before {
        position: absolute;
        top: 0;
        left: -24px;
        display: block;
        width: 24px;
        height: 24px;
        background-image: url(https://res.pandateacher.com/1Q3P2YZZ1629253520390.png);
        background-size: cover;
        content: '';
      }
    }
  }
  .btn {
    width: 686px;
    height: 92px;
    margin: 0 auto 42px auto;
    color: #ffffff;
    font-weight: 600;
    font-size: 28px;
    line-height: 92px;
    text-align: center;
    background: $theme-color;
    border-radius: 12px;
  }
}
</style>
